import React from 'react';
import {Col} from 'react-bootstrap';

import {Terminal} from './terminal';

import './card.css';

export const Card = ({coverImagePath, subtitle, title, ...params} = {}) => {
  const featureEntries = [
    {message: '_ hello', type: 'input'},
    {message: 'Hello world', type: 'output'},
  ];

  const coverImage = (coverImagePath)
    ? <img className="card--cover-image" src={coverImagePath} />
    : <Terminal entries={featureEntries} width={500} />;

  return (
    <Col className="card--wrapper" md={6} xl={4} {...params}>
      <div className="card">
	<div className="card--clipping">
	  <div className="card--cover">
	    {coverImage}
	  </div>
  
          <h3 className="card--title fw-bold text-white">
            {title}
          </h3>
  
          <p className="card--subtitle text-muted mb-0">
            {subtitle}
          </p>
        </div> 
      </div>
    </Col>
  );
};

